import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getNmiTemplatePlaceholders, getNmiTemplates, NmiTemplateDto } from '../endpoints/nmiTemplates';
import { FOCUS_STALE_TIME_MS } from './staleTime';

export const useNmiTemplatesQuery = (): UseQueryResult<NmiTemplateDto[], AxiosError> =>
    useQuery({
        queryKey: ['nmi-templates'],
        staleTime: FOCUS_STALE_TIME_MS,
        queryFn: getNmiTemplates,
    });

export const useNmiTemplatePlaceholdersQuery = (): UseQueryResult<string[], AxiosError> =>
    useQuery({
        queryKey: ['nmi-template-placeholders'],
        staleTime: FOCUS_STALE_TIME_MS,
        queryFn: getNmiTemplatePlaceholders,
    });
